var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-page"},[_c('page-header'),_c('page-main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }